import React, { useEffect, useMemo, useRef, useState } from "react";
import {
	Button,
	Col,
	Form,
	Modal,
	Row,
	Overlay,
	Popover,
} from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllOrgsData, selectAllOrgs, } from "../../redux/actions/getAllOrgsAction";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";

import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useParams } from "react-router-dom";
import moment from "moment";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";

const UpdateCertificate = ({
	showEditCertificate,
	handleCloseEditCertificate,
	certificateData,
	userDataId,
	getUserCv
}) => {
	console.log('certificateData', certificateData);

	const targetRef = useRef(null);

	const sessionId = localStorage.getItem("sessionId");
	const userType = localStorage.getItem("userType");
	const { CandidateId } = useParams();

	const [newEducation, setNewEducation] = useState("");
	const [showTooltip, setShowTooltip] = useState(false);
	const [certificateName, setCertificateName] = useState("");
	const [recognition, setRecognition] = useState("");
	console.log("Recognization===>", recognition)
	const [credentialId, setCredentialId] = useState("");
	const [Description, setDescription] = useState("");
	const [IssueDate, setIssueDate] = useState("");
	const [ExpiredDate, setExpiredDate] = useState(null);
	const [display, setDisplay] = useState(false);
	console.log("Description", Description);

	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);
	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true); // Enable Submit button
	};

	const handleModalClose = () => {
		setTempCity({ value: citySearch, label: cityList.find(c => c.value === citySearch)?.label || certificateData.cityName });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setDisplay(true)
		// setIsSubmitting(true); // Disable the button during submission
		const body = {
			sessionId: sessionId,
			userDataId: userDataId,
			userType: userType,
			instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,

			orgID: getallorgsId === '' || getallorgsId === 0 ? neworgId : getallorgsId,
			// orgID: getallorgsId === "" ? neworgId : getallorgsId,
			issuingOrgType: orgTypeId
				? (orgTypeId === 1 ? 1 : orgTypeId === 2 ? 2 : orgTypeId === 3 ? 3 : orgTypeId === 4 ? 4 : orgTypeId === 5 ? 5
					: null)
				: 5,
			// "issuingOrgType": getallorgsId === '' || getallorgsId === 0 ? neworgId : getallorgsId,
			// "orgID": orgType === '' || orgType === 0 ? neworgType : orgType,
			name: certificateName,
			recognition: recognition,
			credentialId: credentialId,
			description: Description,
			cityId: citySearch,
			issueDate: moment(IssueDate).format("YYYY-MM-DD"),
			isExpirable: isChecked,
			// expirationDate: ExpiredDate === '' || ExpiredDate === null ? null : moment(ExpiredDate).format("YYYY-MM-DD"),
			expirationDate: !isChecked || !ExpiredDate ? null : moment(ExpiredDate).format("YYYY-MM-DD"),
			certId: certificateData.usrDataCertfctnId
		}
		console.log("body", body);
		// if (
		//   certificateName === '' ||
		//   // (getallorgsId === '' && neworgId === '') ||
		//   // (  neworgType === '') ||
		//   recognition === '' ||
		//   credentialId === '' ||
		//   IssueDate === ''
		// ) {
		//   toast.error('Please fill all the required fields');
		// } else {
		try {
			const res = await axios.post("/Resume/UpdateCertification", body);
			toast.success(res.data.message);
			handleCloseEditCertificate();
			getUserCv()
			setDisplay(false)
			setFormChanged(false); // Disable the button after update
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.title);
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
		// }
	}


	const [isChecked, setIsChecked] = useState(false);

	const handleCheckboxChange = (e) => {
		setIsChecked(e.target.checked);
	};

	const dispatch = useDispatch();

	//   Get organization
	const [regdType, setRegdType] = useState("");
	const [getallorgsId, setGetAllOrgsId] = useState("");
	const [orgTypeId, setOrgTypeId] = useState(null);
	const { getallorgsList, selectedgetallId } = useSelector(
		(state) => state.getallorgs
	);

	const reversedOrgList = useMemo(() => {
		return [...getallorgsList].reverse(); // Create a new reversed copy
	}, [getallorgsList]);

	useEffect(() => {
		dispatch(fetchAllOrgsData());
	}, [dispatch]);

	const handleOrganization = (selectedOption) => {
		console.log("selectedOption", selectedOption);
		if (selectedOption) {
			// dispatch(selectAllOrgs(selectedOption.value));
			setGetAllOrgsId(selectedOption.value);
			setOrgTypeId(selectedOption.tagId);
			setRegdType(selectedOption.tagId);
		} else {
			setGetAllOrgsId(null);
		}
	};

	//   Get City
	const [citySearch, setCitySearch] = useState(null);
	const [tempCity, setTempCity] = useState(null);
	const [searchTerm, setSearchTerm] = useState("")
	const [cityNameOption, setCityNameOption] = useState([])
	const { cityList, selectedcityId } = useSelector((state) => state.cities);

	useEffect(() => {
		dispatch(fetchCityData());
	}, [dispatch]);

	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	const handleCityChange = (option) => {
		setTempCity(option); // UI ke liye value change karo
		// if (option) setCitySearch(option.value); // Sirf tab update ho jab user select kare
		handleFieldChange(setCitySearch, option ? option.value : "");
	};

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			console.log("Get City Name List==>", response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);

	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};

	useEffect(() => {
		if (certificateData) {
			setCertificateName(certificateData?.name)
			setRecognition(certificateData?.recognition)
			setDescription(certificateData?.description)
			setOrgTypeId(certificateData?.issuingOrgType)
			// setCitySearch(certificateData?.cityId)
			// dispatch(fetchCityData(certificateData?.cityName));
			setCitySearch(certificateData.cityId || ""); // Backend wali value safe rakho
			setTempCity({ value: certificateData.cityId, label: certificateData.cityName }); // UI ke liye
			setCredentialId(certificateData?.credentialId)
			setIssueDate(certificateData?.issueDate)
			setExpiredDate(certificateData?.expirationDate)
			setGetAllOrgsId(certificateData?.orgId)
			setIsChecked(certificateData?.isExpirable)
		}
	}, [certificateData, showEditCertificate])

	const toggleTooltip = () => {
		console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};
	const [fileName, setFileName] = useState(""); // State to store selected filename
	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};
	const [InsName, setInsName] = useState("");
	const [OrganizationName, setOrganizationName] = useState("");
	const [orgCity, setOrgCity] = useState(null);
	const [neworgType, setneworgType] = useState('');
	const [neworgId, setneworgId] = useState('');
	const handleCitySelect1 = (selectedOption) => {
		if (selectedOption) {
			setOrgCity(selectedOption.value);
		} else {
			setOrgCity(null);
		}
	};

	const handleSaveInstitution = async () => {
		// setDisplay(true);
		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdGeneralOrg");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			console.log("hdhdhjhad", res);
			// setGenOrgInstId(res.data.responseData);
			setneworgType(res.data.responseData.value)
			setneworgId(res.data.responseData.id)
			toast.success(`${res.data.message} The newly created Organization is now available at the top of the dropdown. Please select it.`);
			dispatch(fetchAllOrgsData());

			// **Enable the submit button after saving**
			setFormChanged(true);
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.title);
			}
		}
	};

	console.log(InsName);


	return (
		<>
			<Modal
				show={showEditCertificate}
				onHide={handleCloseEditCertificate}
				centered
				size="lg"
			>
				<Modal.Header >
					<Modal.Title>Update certificate</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseEditCertificate} />
				</Modal.Header>
				<Modal.Body className="settings">
					<Row>
						{/* Certificate Name */}
						<Col md={6} className="mb-2">
							<div className="post-form-group mb-0">
								<label htmlFor="certificateName">
									Certificate name{" "}<span style={{ color: "red" }}> *</span>
								</label>
								<input type="text" placeholder="Enter certificate name"
									value={certificateName}
									// onChange={(e) => { setCertificateName(e.target.value)}}
									// onChange={(e) => setCertificateName(e.target.value)} // Track changes
									onChange={(e) => handleFieldChange(setCertificateName, e.target.value)}

								/>
								{display && !certificateName ? (
									<span className="error_msg_lbl">Add certification name </span>
								) : null}
							</div>
						</Col>

						{/* Organization */}
						<Col md={6} className="org-styles mb-2">
							<Form.Group controlId="organization">
								<Form.Label className="class-type">
									Organization<span style={{ color: "red" }}> *</span>
								</Form.Label>
								<div className="form-group">
									{/* Remove the conditional rendering that switches between input and dropdown */}
									<div className="post-form-group">
										<ReactSelect
											options={reversedOrgList}
											// onChange={(selectedOption) => handleOrganization(selectedOption)}
											onChange={(selectedOption) =>
												handleFieldChange(handleOrganization, selectedOption)
											}
											value={
												reversedOrgList.find(
													(option) => {
														// Check if we should use a newly created org or one from the list
														if (InsName !== "" && InsName !== null) {
															// This should match the newly created org in the list
															return option.value === InsName;
														} else {
															// This matches existing orgs as before
															return option.value === getallorgsId && option.tagId === orgTypeId;
														}
													}
												) || null
											}
											getOptionValue={(option) => `${option.value}-${option.tagId}`}
											formatOptionLabel={(option) => (
												<div style={{ fontWeight: option.tagId === 1 || option.tagId === 2 ? "bold" : "normal" }}>
													{option.label}<span>({option.tagId === 1 ? "Insitution" : option.tagId === 2 ? "Company" : option.tagId === 3 ? "UnredgCompany" : option.tagId === 4 ? "UnredgInstitution" : option.tagId === 5 ? "UnRegdGeneralOrg" : ""})</span>
												</div>
											)}
											placeholder="Select Organization"
											classNamePrefix="react-select"
											className="form-control Dark-Input-from-group"
											styles={customStyles}
											isClearable
										/>
									</div>
								</div>
							</Form.Group>
							<a
								href="#"
								ref={targetRef}
								onClick={(e) => {
									e.preventDefault();
									toggleTooltip();
								}}
								className="createModal"
							>
								Create New
							</a>
							<Overlay
								target={targetRef.current}
								show={showTooltip}
								placement="right"
								rootClose
								container={document.querySelector(".modal")}
								onHide={() => setShowTooltip(false)}
							>
								<Popover id="popover-basic" className="overlay-popover-modal">
									<Popover.Header as="h3" className="Dark-Body-Card-group">Create organization</Popover.Header>
									<Popover.Body className="Dark-Body-Card-group">
										<Form>
											<div>
												<label className="mb-1 Text-mb-Create">Org name</label>
												<input
													type="text"
													value={OrganizationName}
													onChange={(e) => {
														setOrganizationName(e.target.value);
														setInsName(e.target.value);
													}}
													placeholder="Enter Org name"
													className="mb-2 form-control Dark-Input-from-group"
												/>
											</div>
											<div>
												<label className="mb-1 Text-mb-Create">City</label>
												<ReactSelect
													options={cityNameOption}
													onInputChange={(value) => setSearchTerm(value)}
													onChange={handleCitySelectOrg}
													placeholder="Search & Select City"
													classNamePrefix="react-select"
													className="form-control Dark-Input-from-group"
													styles={customStyles}
													isClearable
												/>
											</div>
											<div className=" mt-2 mb-2">
												<label className="mb-1 Text-mb-Create">Org logo</label>
												<input
													type="file"
													id="lastName"
													className="form-control Dark-Input-from-group"
													placeholder=""
													onChange={handleFileChange}
												/>
											</div>
											<div className="d-flex justify-content-end">
												<Button
													variant="primary"
													size="sm"
													onClick={() => {
														handleSaveInstitution();
														setShowTooltip(false);
													}}
													className="me-2"
												>
													Save
												</Button>
												<Button
													variant="secondary"
													size="sm"
													onClick={() => setShowTooltip(false)}
												>
													Cancel
												</Button>
											</div>
										</Form>
									</Popover.Body>
								</Popover>
							</Overlay>
						</Col>

						{/* Recognition */}
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="recognition">
									Recognition{" "}<span style={{ color: "red" }}> *</span>
								</label>
								<input type="text" placeholder="Enter recognition"
									value={recognition}
									// onChange={(e) => { setRecognition(e.target.value)}}
									// onChange={(e) => setRecognition(e.target.value)} // Track changes
									// onChange={(option) => handleFieldChange(setRecognition, option ? option.value : "")} // Track changes
									onChange={(e) => handleFieldChange(setRecognition, e.target.value)}


								/>
								{display && !recognition ? (
									<span className="error_msg_lbl">Add recognition </span>
								) : null}
							</div>
						</Col>

						{/* Credential ID */}
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="credentialId">
									Credential id{" "}<span style={{ color: "red" }}> *</span>
								</label>
								<input type="text" placeholder="Enter credential ID"
									value={credentialId}
									// onChange={(e) => {setCredentialId(e.target.value) }}
									// onChange={(e) => setCredentialId(e.target.value)} // Track changes
									onChange={(option) => handleFieldChange(setCredentialId, option ? option.value : "")} // Track changes

								/>
								{display && !credentialId ? (
									<span className="error_msg_lbl">Add credential id </span>
								) : null}
							</div>
						</Col>

						{/* City */}
						<Col md={6} className="mb-2">
							<Form.Group controlId="city">
								<Form.Label className="class-type">
									City
									{/* <span style={{ color: "red" }} className="ms-2">
                    *
                  </span> */}
								</Form.Label>
								<div className="post-form-group">
									<ReactSelect
										options={cityList}
										onInputChange={handleCityInputChange}
										onChange={handleCityChange}
										value={tempCity} // UI me last selected value dikhani hai
										placeholder="Search & Select City"
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										styles={customStyles}
										isClearable={true}
										onBlur={handleModalClose}
									/>
									{/* {display && !citySearch ? (
                    <span className="error_msg_lbl">Search & Select City </span>
                  ) : null} */}
								</div>
							</Form.Group>
						</Col>

						{/* Description */}
						<Col md={6} className="mb-2">
							<div className="post-form-group">
								<label htmlFor="description">
									Description{" "}
								</label>
								<input type="text" placeholder="Enter description"
									value={Description}
									// onChange={(e) => { setDescription(e.target.value) }}
									// onChange={(e) => setDescription(e.target.value)} // Track changes
									// onChange={(option) => handleFieldChange(setDescription, option ? option.value : "")} // Track changes
									onChange={(e) => handleFieldChange(setDescription, e.target.value)}


								/>
							</div>
						</Col>

						{/* Issue Date */}
						<Col md={6} className="mb-2">
							<div className="w-100 post-form-group Flatpickr-Calender-Class">
								<label htmlFor="issueDate col-md-12">
									Issue date<span className="text-danger"> *</span>
								</label>
								<Flatpickr className="form-control Dark-Input-from-group" id="issueDate"
									value={IssueDate}
									options={{
										maxDate: new Date(), // Disable future dates
										static: true, // Keeps the calendar visible on click         
									}}
									// onChange={(date) => setIssueDate(date[0])}
									// onChange={(date) => setIssueDate((date[0]))} // Track changes
									onChange={(date) => handleFieldChange(setIssueDate, (date[0]))} // Track changes

								/>
								{display && !IssueDate ? (
									<span className="error_msg_lbl">Select issue date </span>
								) : null}
							</div>
						</Col>

						<Col md={6} className="mb-2">
							<div className="mt-4">
								<input
									type="checkbox"
									style={{ width: "40px" }}
									checked={isChecked} // Bind the checkbox to state
									//onChange={handleCheckboxChange}
									onChange={(e) => setIsChecked(e.target.checked)}
								//   id={`check-${item.id}`}
								//   id={`check-${item.id}`}
								//   checked={selectedWorkLevelList.includes(item.id)}
								//   onChange={() => setPresent(true)}
								/>
								<label htmlFor="about">IsExpirable</label>
							</div>
						</Col>

						{/* Expiration Date */}
						{isChecked && (
							<Col md={6} className="mb-2">
								<div className="col-md-6 mt-2 w-100 Flatpickr-Calender-Class">
									<label htmlFor="expirationDate col-md-12">
										Expiration date
									</label>
									<Flatpickr className="form-control Dark-Input-from-group" id="expirationDate"
										value={ExpiredDate}
										options={{
											minDate: IssueDate || null, // Set minDate to startDate
											static: true, // Keeps the calendar visible on click         
										}}
										// onChange={(date) => setExpiredDate(date[0])}
										// onChange={(date) => setExpiredDate((date[0]))} // Track changes
										onChange={(date) => handleFieldChange(setExpiredDate, (date[0]))} // Track changes

									/>
								</div>
							</Col>
						)}

						{/* Checkbox */}
					</Row>

					{/* Submit and Close Buttons */}


					<div className="d-flex justify-content-center mt-4">
						<div className="add-class-submit-button mt-4 d-flex justify-content-center">
							<div className="khojPrimaryBtn ms-3"
								onClick={handleSubmit}
								style={{ cursor: formChanged ? "pointer" : "default" }}
							>
								<a href="#/"
									// className=""
									// onClick={handleSubmit}
									className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
									disabled={!formChanged || isSubmitting}
									style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
								>
									Submit
								</a>
							</div>
						</div>
					</div>

				</Modal.Body>
			</Modal>
		</>
	);
};

export default UpdateCertificate;
